/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function () {
  var mobileButton = $('#menu-button');
  var mobileNavigation = $('#mobile-navigation');
  var toggleDropdownLink = $('.js-dropdown-toggle');
  const $globalOverlay = $('#global-overlay');
  var body = $('body');

  mobileButton.click(function () {
    $(this).toggleClass('menu-button--active');
    mobileNavigation.stop().slideToggle();
    //    $('body').toggleClass('body-overlay');
    $globalOverlay.toggleClass('overlay--shown')

    if ($globalOverlay.hasClass('overlay--shown')) {
      bodyScrollLock.disableBodyScroll(mobileNavigation);
    } else {
      bodyScrollLock.enableBodyScroll(mobileNavigation);
    }
  });

  toggleDropdownLink.click(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next().stop().slideToggle();

    return false;
  });

  $(document).on('click', '.overlay--global', e => {
    mobileButton.removeClass('menu-button--active');
    mobileNavigation.slideUp();
    $globalOverlay.removeClass('overlay--shown')
    bodyScrollLock.enableBodyScroll(mobileNavigation);
  })

  // body.on('click touch', e => {
  //     console.log(e.target)

  //     if (e.target.id == 'menu-button' || $(e.target).parents('#menu-button').length) {
  //         return true
  //     }

  //     if (!$(e.target).parents('#mobile-navigation').length) {
  //         console.log('close')
  //         mobileButton.removeClass('menu-button--active');
  //         mobileNavigation.slideUp();
  //         // body.removeClass('body-overlay');
  //         $globalOverlay.removeClass('overlay--shown')
  //         bodyScrollLock.enableBodyScroll(mobileNavigation);
  //     } else {
  //         return true;
  //     }
  // });

});
$(document).on('ready', function () {

  const formVariations = ['login', 'register', 'recover', 'reset', 'recover-message']

  window.accountPopups = new Vue({
    el: '#vue-popups',
    data() {
      return {
        activeForm: '',
        isActive: false,
        recoverSuccess: false,
        errorMessage: '',
        reset_id: '',
        reset_token: ''
      }
    },
    methods: {
      checkFormFromURL() {
        if (location.hash == '#recover') return this.activeForm = 'recover'

        const urlParams = new URLSearchParams(location.search)

        if (urlParams.has('form') && formVariations.includes(urlParams.get('form'))) {
          this.activeForm = urlParams.get('form')
          this.isActive = true
        }

        if (urlParams.has('token') && urlParams.has('id')) {
          this.reset_id = urlParams.get('id');
          this.reset_token = urlParams.get('token');
        }

        this.errorMessage = urlParams.get('errors');
      },
      togglePopup() {
        this.activeForm = 'login';
        this.isActive = !this.isActive;
      },
      writeReferrer() {
        localStorage.setItem('formReferrer', `${location.origin}${location.pathname}`)
      }
    },
    watch: {
      activeForm(nV, oV) {
        if (oV != '' && nV != oV) this.errorMessage = ''
      },
      isActive(v) {
        if (v) {
          bodyScrollLock.disableBodyScroll(this.$el);
        } else {
          bodyScrollLock.enableBodyScroll(this.$el);
          const removedForm = new URLSearchParams(location.search);
          removedForm.delete('form');
          removedForm.delete('errors');
          history.replaceState(null, null, `${location.origin}${location.pathname}${location.hash}?${removedForm}`)
        }
      }
    },
    mounted() {
      this.checkFormFromURL();
      localStorage.removeItem('formReferrer')
    }
  });

  $(document).on('click', '.js-account-popup-toggler', e => {
    if (window.innerWidth <= 767) return true

    e.preventDefault();

    window.accountPopups.togglePopup();
  });
});
$(document).ready(function () {
  // Home Featured blog slider
  let blogSlider = $('.js-featured-blog');

  if (blogSlider.length > 0) {
    let blogSliderOptions = {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: false,
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            autoplay: false,
            centerMode: true,
            centerPadding: '20px'
          }
        }
      ]
    };

    initSliderOnMobile(blogSlider, blogSliderOptions);
  }

  // Home press quotes slider
  let pressQuotesProductSlider = $('.product-press-quotes__slider');
  if (pressQuotesProductSlider.length > 0) {
    pressQuotesProductSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      autoplay: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    })
  }

  // Product Main slider

  // Product reviews slider
  let reviewProductSlider = $('#review-product-slider');

  if (reviewProductSlider.length > 0) {
    reviewProductSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      dots: true,
      appendDots: $('#product-reviews'),
      prevArrow: '<button type="button" role="button" aria-label="Previous" class="slick-arrow slick-prev"></button>',
      nextArrow: '<button type="button" role="button" aria-label="Next" class="slick-arrow slick-next"></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true
          }
        }
      ]
    })
  }

  // Product Steps slider
  let stepsSlider = $('#product-steps');
  let stepsSliderOptions = {
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          autoplay: false
        }
      }
    ]
  };

  initSliderOnMobile(stepsSlider, stepsSliderOptions);

  /*
  * Parameters:  slider - jQuery object. sliderOptions - object with slick settings.
  * */
  function initSliderOnMobile(slider, sliderOptions) {
    if (slider.length > 0) {

      if (window.innerWidth < 992) {
        slider.slick(sliderOptions);
      }

      $(window).on('resize', function () {
        if (window.innerWidth < 992 && !slider.hasClass('slick-initialized')) {
          slider.slick(sliderOptions);
        } else if (window.innerWidth > 991 && slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
      });
    }
  }

  $(document).keyup(function (e) {
    var targetId = e.target.id;
    if (targetId === "note") {
      var count = $("#note").val().length;
      $('#minicart-note__count').text(count);
    }
  });
});
$(document).ready(function () {
  initInstafeed();
});

function initInstafeed() {
  var instafeed = $("#instafeed");
  if (instafeed.length) {

    var token = instafeed.data('token');
    var userId = instafeed.data('userid');
    var photoCount = Number(instafeed.attr('data-count'));

    if (!token || !userId) {
      return;
    }

    var feed = new Instafeed({
      get: 'user',
      userId: userId,
      resolution: 'standard_resolution',
      accessToken: token,
      limit: photoCount,
      template: '<div class="instagram__col"><div class="instagram__picture"><a class="instagram__image" href="{{link}}" target="_blank" style="background-image:url({{image}})"></a></div></div>'
    }
    );
    feed.run();
  }
}

var breakpointMobile = 700;
$(document).ready(function () {
  if ($('[data-slider-config]').length > 0) {
    let $sliders = $('[data-slider-config]:not(.slick-initialized)');
    $sliders.each(function () {
      let sliderParam = jQuery.parseJSON($(this).attr('data-slider-config')),
        slideToShow = sliderParam.slidesToShow,
        paddingSlide = 0,
        centerSlideMode = false;

      if (sliderParam.centerMode) {
        centerSlideMode = sliderParam.centerMode;
      }
      if (sliderParam.centerPadding) {
        paddingSlide = sliderParam.centerPadding;
      }
      if (sliderParam.slidesToShow > 3 && sliderParam.slidesToShow > sliderParam.slidesToShowMobile) {
        slideToShow = sliderParam.slidesToShow - 1
      }

      var breakpointMobile = 998,
        isChanging = false,
        isFiltered = false;

      $(this).on('init breakpoint', function (event, slick) {
        if (!isChanging) {
          isChanging = true;
          console.log(slick.activeBreakpoint);
          if (slick.activeBreakpoint && slick.activeBreakpoint <= breakpointMobile) {
            if (!isFiltered) {
              slick.slickUnfilter();
              slick.slickFilter(':not(.desktop)');
              isFiltered = true;
            }
          } else if (slick.activeBreakpoint && slick.activeBreakpoint > breakpointMobile) {
            if (!isFiltered) {
              slick.slickUnfilter();
              slick.slickFilter(':not(.mobile)');
              isFiltered = true;
            }
          }
          isFiltered = false;
          isChanging = false;
        }
      }).slick({
        slidesToScroll: 1,
        pauseOnHover: true,
        prevArrow: '<button type="button" role="button" aria-label="Previous" class="slick-arrow slick-prev"></button>',
        nextArrow: '<button type="button" role="button" aria-label="Next" class="slick-arrow slick-next"></button>',
        slidesToShow: sliderParam.slidesToShow,
        arrows: sliderParam.arrow,
        autoplay: sliderParam.autoPlay,
        autoplaySpeed: sliderParam.speed * 1000,
        dots: sliderParam.dots,
        adaptiveHeight: sliderParam.adaptiveHeight,
        responsive: [
          { breakpoint: 7680 },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: slideToShow,
              arrows: sliderParam.arrow,
              dots: sliderParam.dots
            }
          },
          {
            breakpoint: 998,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: sliderParam.slidesToShowMobile,
              centerMode: centerSlideMode,
              centerPadding: paddingSlide
            }
          }
        ]
      });

    });
  }


  if ($('.hero-banner').length > 0) {
    $(document).on('mouseenter', '.hero-banner', function () {
      let wrapperCTA = $(this).find('.hero-banner__block-wrapper');
      if (wrapperCTA.length > 0) {
        IsVisible($(wrapperCTA));
      }
    })
  }

  if ($('.js-videoIframe').length > 0 && $('.js-videoPoster').length > 0) {
    $(document).on('click', '.js-videoPoster', function (e) {
      e.preventDefault();
      var poster = $(this),
        wrapper = poster.closest('.js-videoWrapper');
      videoPlay(wrapper);
    });
    $(document).on('click', '.js-videoClose', function (e) {
      e.preventDefault();
      var closeButton = $(this),
        wrapper = closeButton.closest('.js-videoWrapper');
      videoPlay(wrapper);
    });
    function videoPlay(wrapper) {
      var iframe = wrapper.find('.js-videoIframe'),
        src = wrapper.data('src');
      if (wrapper.hasClass('home-story__video--active')) {
        wrapper.removeClass('home-story__video--active');
        iframe.attr('src', '');
      } else {
        wrapper.addClass('home-story__video--active');
        iframe.attr('src', src);
      }
    }
  }
  initScrollToAnchor();

  if (location.pathname.includes('/products/')) {
    initProductTopNavigation();
  }

  function initScrollToAnchor() {
    let anchorLink = $('.js-scroll-to-anchor');
    if (anchorLink.length > 0) {
      anchorLink.click(function (e) {
        e.preventDefault();
        let headerHeight = $('#header-main').innerHeight();
        let productNavHeight = $('#product-navigation').innerHeight();

        anchorLink.not(this).removeClass('active');
        $(this).addClass('active');

        let linkedSection = $($(this).attr('href'));

        $('html, body').animate({
          scrollTop: linkedSection.offset().top - headerHeight - productNavHeight
        }, 600);
      })
    }
  }

  function initProductTopNavigation() {
    let $anchorLinks = $('.js-scroll-to-anchor');
    if (!$anchorLinks.length) { return };

    const scrollbar = Scrollbar.init($anchorLinks.parents('ul').first()[0]);
    let blocks = [].slice.call(document.querySelectorAll($anchorLinks.toArray().map(x => x.getAttribute('href')).join(', '))).map(x => ({ el: x, offset: $(x).offset().top }));
    let initialPositions = {};

    for (const anchorLink of $anchorLinks) {
      initialPositions[anchorLink.getAttribute('href')] = $(anchorLink).offset().left
    }

    let lastWidth = window.innerWidth;

    window.addEventListener('resize', () => {
      if (lastWidth != window.innerWidth) {
        $anchorLinks.parents('ul').first()[0].scrollTo({ left: 0, behavior: 'smooth' });

        for (const anchorLink of $anchorLinks) {
          initialPositions[anchorLink.getAttribute('href')] = anchorLink.offsetLeft;
          anchorLink.classList.remove('active')
        }

        window.scrollTo({
          top: window.scrollY + 10,
          behavior: 'smooth'
        })
      }

      blocks = blocks.map(x => {
        x.offset = $(x.el).offset().top;
        return x
      });

      lastWidth = window.innerWidth
    });

    window.addEventListener('scroll', e => {
      if (!location.pathname.includes('/products/')) return true;

      const windowScrollTop = $(window).scrollTop();

      const closestEl = blocks
        .map(x => {
          x.diff = (windowScrollTop + window.innerHeight / 2) - x.offset;
          return x;
        })
        .filter(x => x.diff > 0)
        .sort((a, b) => a.diff - b.diff)
      [0].el;

      const newActive = $anchorLinks.toArray().find(x => {
        return x.getAttribute('href') == '#' + closestEl.id
      });

      if (newActive) {
        if (newActive.classList.contains('active')) return;

        $anchorLinks.removeClass('active');
        newActive.classList.add('active');

        const $newActive = $(newActive);
        const $parent = $newActive.parents('ul').first();

        const newActiveWidth = $newActive.width();
        const fullWidth = $parent[0].scrollWidth;
        const viewWidth = $parent.width();

        const initalBegin = initialPositions[newActive.getAttribute('href')];

        const neededSpace = viewWidth / 2 - newActiveWidth / 2;
        const newOffset = initalBegin - neededSpace;

        scrollbar.scrollIntoView(newActive, {
          offsetLeft: neededSpace
        });
        // if (newOffset < 0) {
        //     // $parent[0].scrollTo({
        //     //     left: 0,
        //     //     behavior: 'smooth'
        //     // })
        //     // $parent.stop().animate({
        //     //     scrollLeft: 0
        //     // }, 400)
        //     scrollbar.scrollTo(0, 0, 500)
        // } else if (fullWidth - viewWidth < newOffset) {
        //     // $parent[0].scrollTo({
        //     //     left: fullWidth - viewWidth,
        //     //     behavior: 'smooth'
        //     // })
        //     // $parent.stop().animate({
        //     //     scrollLeft: fullWidth - viewWidth
        //     // }, 400)
        //     scrollbar.scrollTo(scrollbar.getSize().content.width, 0, 500)
        // } else {
        //     // $parent[0].scrollTo({
        //     //     left: newOffset,
        //     //     behavior: 'smooth'
        //     // })
        //     // $parent.stop().animate({
        //     //     scrollLeft: newOffset
        //     // }, 400)
        //     scrollbar.scrollTo(newOffset, 0, 500)
        // }
      }
    })
  }

  initProductAccordion();
  function initProductAccordion() {
    let toggleElement = $('.js-accordion-toggle');
    if (toggleElement.length > 0) {
      toggleElement.click(function (e) {
        e.preventDefault();
        if (window.innerWidth < 992) {
          toggleElement.not(this).each(function () {
            $(this).next().slideUp();
            $(this).removeClass('active');
          });
          $(this).toggleClass('active');
          $(this).next().stop().slideToggle();
        }
      });
      $(window).resize(function () {
        if (window.innerWidth > 991) {
          toggleElement.next().attr('style', '');
        }
      });
    }
  }
  initFaqPage();

  $('.faq-main__accordion .toggle').click(function (e) {
    e.preventDefault();
    var $this = $(this);
    $('.faq-main__accordion .toggle').not(this).each(function () {
      $(this).next().stop().slideUp();
      $(this).find('.icon').removeClass('rotate-svg');
    });
    $this.next().stop().slideToggle();
    $this.find('.icon').toggleClass('rotate-svg');
  });


  function initFaqPage() {
    let categories = $('.js-faq-categories li'),
      mobileToggle = $('.js-mobile-faq-toggle'),
      faqCategoriesList = $('.js-faq-categories');

    if (!categories.length) {
      return;
    }

    categories.on('click', function () {
      let targetCategory = $(this).attr('data-category');
      let offset = ($('.faq-main__accordion').find(`#${targetCategory}`).offset().top - parseInt(document.documentElement.style.getPropertyValue('--product-nav-position')))
      $('.js-faq-categories').removeClass('open');

      //Scroll to block
      $('html, body').animate({
        scrollTop: offset
      }, 600);
    });

    $(document).on('scroll', function () {
      let offset = parseInt(document.documentElement.style.getPropertyValue('--product-nav-position')),
        scrollPos = $(document).scrollTop() + offset + 50;

      //sett default
      //css - position - fix bug with sticky subheader
      if ($(document).scrollTop() <= offset) {
        $('.faq-page-nav').css({ 'position': 'absolute' });
        $('.js-faq-categories > li').first().addClass('active');
      } else {
        $('.faq-page-nav').css({ 'position': 'fixed' });
      }

      $('.js-faq-categories > li').each(function (index, item) {
        const catName = $(item).data('category');
        const refElement = $(`.faq-main__accordion #${catName}`);

        if ((refElement.position().top - ($(refElement).height() / 2)) <= scrollPos) {
          $('.js-faq-categories > li').removeClass("active");
          $(this).addClass('active');
        } else {
          $(this).show();
          $(this).removeClass('active');
        }
      })
    });

    initMobileCategorySelect();
    function initMobileCategorySelect() {
      mobileToggle.click(function () {
        $(this).toggleClass('open');
        faqCategoriesList.toggleClass('open');
      })
    }

    if (location.search.indexOf('toggle=') !== -1 && $('.js-faq-categories li[data-category="' + location.search.split('toggle=')[1].split('&')[0] + '"]').length) {
      setTimeout(function () {
        $('.js-faq-categories li[data-category="' + location.search.split('toggle=')[1].split('&')[0] + '"]').click();
        history.pushState("", document.title, window.location.pathname
          + '#subscription-service');
      }, 300)
    }
  }

  if ($('.js-our-story-video__iframe').length > 0 && $('.js-our-story-video__poster').length > 0) {
    $(document).on('click', '.js-our-story-video__poster', function (e) {
      e.preventDefault();
      var poster = $(this);
      var wrapper = poster.closest('.js-our-story-video__wrapper');
      videoPlay(wrapper);
    });

    function videoPlay(wrapper) {
      var iframe = wrapper.find('.js-our-story-video__iframe');
      var src = iframe.data('src');

      wrapper.addClass('our-story-video__wrapper--active');
      iframe.attr('src', src);
    }
  }

  initMobilePaneldAddToCart();

  function initMobilePaneldAddToCart() {
    let fixedPanel = $('#fixed-add-to-cart');

    if (!fixedPanel.length) {
      return false;
    }

    let iScrollPos = 0;
    let firstShow = true;
    let productOverview = $('#product-overview');
    let overviewBottomPosition = productOverview.offset().top + productOverview.innerHeight() - $(window).innerHeight() + 100;

    // window.addEventListener('scroll', () => {
    //     if ($('.js-scroll-to-anchor.active').attr('href') == '#product-overview' || $(window).scrollTop() < $('#product-overview').height() - 150) {
    //         fixedPanel.removeClass('mobile-cart-form--active');
    //         firstShow = true;
    //         return true;
    //     }
    // });

    if ($(window).scrollTop() >= overviewBottomPosition) {
      fixedPanel.addClass('mobile-cart-form--active');
    }

    $(window).scroll(function () {
      if (window.innerWidth >= 992) return true;

      let iCurScrollPos = $(window).scrollTop();

      if ($(window).scrollTop() >= overviewBottomPosition) {
        fixedPanel.addClass('mobile-cart-form--active');
        // firstShow = false;
      } else {
        fixedPanel.removeClass('mobile-cart-form--active');
      }

      if (iCurScrollPos < 100) {
        fixedPanel.removeClass('scroll-down')
        return true
      }

      if ($(document).height() - iCurScrollPos - window.innerHeight < 50) {
        fixedPanel.addClass('scroll-down')
        return true
      }

      if (iCurScrollPos > iScrollPos) {
        //Scrolling Down
        fixedPanel.addClass('scroll-down')
      } else {
        //Scrolling Up
        fixedPanel.removeClass('scroll-down')
      }

      iScrollPos = iCurScrollPos;
    });

    // document.body.addEventListener('touchmove', function () {
    //
    //     if (window.innerWidth >= 992) return true;
    //
    //     let iCurScrollPos = $(window).scrollTop();
    //
    //     if (firstShow && $(window).scrollTop() >= overviewBottomPosition) {
    //         fixedPanel.addClass('mobile-cart-form--active');
    //         firstShow = false;
    //     }
    //
    //     if(iCurScrollPos < 100) {
    //         fixedPanel.removeClass('scroll-down')
    //         return true
    //     }
    //
    //     if ($(document).height() - iCurScrollPos - window.innerHeight < 50) {
    //         fixedPanel.addClass('scroll-down')
    //         return true
    //     }
    //
    //     if (iCurScrollPos > iScrollPos) {
    //         //Scrolling Down
    //         fixedPanel.addClass('scroll-down')
    //     } else {
    //         //Scrolling Up
    //         fixedPanel.removeClass('scroll-down')
    //     }
    //
    //     iScrollPos = iCurScrollPos;
    // });
  }

  initFixedCartForm();

  function initFixedCartForm() {

    let footer = $('#footer-main');

    let fixedCartForm = $('#fixed-cart-form');
    let productOverview = $('#product-overview');

    if (fixedCartForm.length > 0 && productOverview.length > 0) {

      let overviewBottomPosition = productOverview.offset().top + productOverview.innerHeight() - 120;

      if ($(window).scrollTop() >= overviewBottomPosition) {
        fixedCartForm.addClass('fixed-cart-form--active');
      }

      $(window).scroll(function () {

        if (window.innerWidth > 991) {

          let footerPosition = footer.offset().top;
          overviewBottomPosition = productOverview.offset().top + productOverview.innerHeight() - 120;

          if ($(window).scrollTop() >= overviewBottomPosition) {
            fixedCartForm.addClass('fixed-cart-form--active');
          } else {
            fixedCartForm.removeClass('fixed-cart-form--active');
          }

          if ($(window).scrollTop() + window.innerHeight >= footerPosition) {
            fixedCartForm.addClass('fixed-cart-form--under-footer');
          } else {
            fixedCartForm.removeClass('fixed-cart-form--under-footer');
          }
        }
      });
    }
  }

  function IsVisible(element) {
    element.addClass('is-visible');
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const namespace = '.js-recharge-product-form';

  const subscriptionsParams = {
    "_frequency_type": "2",
    "_frequency_type_text": "Week(s)",
    "_group_id": "25872",
  };

  checkProductPreorder();

  var _learnq = _learnq || [];
  $(document).on('click', '[data-add-to-cart]', function () {
    let klaviyo_item = window.item

    if (!klaviyo_item && $(this).attr('data-item')) {
      klaviyo_item = $.parseJSON($(this).attr('data-item'))
    }

    if (klaviyo_item) {
      _learnq.push(['track', 'Added to Cart', klaviyo_item]);
    }

    let $addToCartButton = $(this),
      addToCartText = $(this).find('[data-add-to-cart-text]');
    if (addToCartText.text() === window.theme.strings.addToCart || addToCartText.text() === window.theme.strings.addToCartSet) {
      let string = window.theme.strings.addToCart;
      if (addToCartText.text() === window.theme.strings.addToCartSet) {
        string = window.theme.strings.addToCartSet;
      }
      $addToCartButton.attr('disabled', 'disabled');
      addToCartText.text(window.theme.strings.addingToCart);
      setTimeout(() => {
        $addToCartButton.removeAttr('disabled');
        addToCartText.text(string);
      }, 2000);
    }
  })

  $(document).on('input', '[name="quantity"]', e => {

    // if (e.target.value <= 0) return e.target.value = 1;

    if (e.target.value >= 100) return e.target.value = 99;
  });

  $(document).on('change', '[name="quantity"]', e => {
    if (e.target.value <= 0) return e.target.value = 1;
  });

  $(document).on('click', namespace + ' [data-add-to-cart]', e => {

    e.preventDefault();
    const $form = $(e.target).parents(namespace);
    const variantSelector = $form.find('[data-variant-selector]');
    let variantId = variantSelector.val()

    if (variantSelector.length > 1) {
      variantId = variantSelector.toArray().find(x => x.checked).value
    }

    const frequency = $form.find('[name="frequency"]').val().trim();
    const quantity = parseInt($form.find('[name="quantity"]').val());
    const plan_allocation = $form.find('[name="frequency"] option[value="' + frequency + '"]').attr('data-allocation')

    const isSubscription = frequency != 'one-time';
    const itemInCart = CartJS.cart.items.find(x => x.id == variantId);
    const button = 'addToCart' in e.target.dataset ? e.target : e.target.parentElement
    let calculatedSubscriptionsParams = isSubscription ? Object.assign({}, subscriptionsParams) : {}

    if (button.classList.contains('button--preorder')) {
      calculatedSubscriptionsParams['Pre-order'] = preorderProducts[$form.data('product-handle')].buttonLabel
      if (!isSubscription) {
        calculatedSubscriptionsParams['_is_prepaid'] = true;
        calculatedSubscriptionsParams['_total_recurrences'] = 1;
      }
    }

    if (itemInCart) {
      const initialQuantity = itemInCart.quantity;
      if ($(`[data-sample-id="${variantId}"]`).length) {
        const sampleId = $(`[data-sample-id="${variantId}"]`).attr('data-variant-id');
        CartJS.updateItemQuantitiesById({
          [sampleId]: 0,
          [variantId]: 0
        }, {
          "success": function (data) {
            removedItem(initialQuantity)
          }
        });
      } else {
        CartJS.updateItemQuantitiesById({
          [variantId]: 0
        }, {
          "success": function (data) {
            removedItem(initialQuantity)
          }
        });
      }
    } else {
      removedItem(0)
    }

    function removedItem(initialQuantity) {
      try {
        if (isSubscription) {
          const sampleId = $(`.sample_subscription[data-variant-id="${variantId}"]`).attr('data-id');
          CartJS.addItem(variantId, quantity, Object.assign({}, calculatedSubscriptionsParams, {
            "selling_plan": parseInt(plan_allocation),
            "_frequency_num": frequency,
            "has_sample": sampleId
          }), {
            "success": function (data) {
              itemAdded(data)
            }
          });
          if (sampleId) {
            CartJS.addItem(sampleId, quantity, {
              "sample": variantId
            }, {
              "success": function (data) {
                itemAdded(data)
              }
            });
          }
        } else {
          const sampleId = $(`.sample[data-variant-id="${variantId}"]`).attr('data-id');
          if (sampleId) {
            CartJS.addItem(variantId, initialQuantity + quantity, {
              "has_sample": sampleId
            }, {
              "success": function (data) {
                CartJS.addItem(sampleId, initialQuantity + quantity, {
                  "sample": variantId
                }, {
                  "success": function (data) {
                    itemAdded(data)
                  }
                });
              }
            });
          } else {
            CartJS.addItem(variantId, initialQuantity + quantity, calculatedSubscriptionsParams, {
              "success": function (data) {
                itemAdded(data)
              }
            });
          }
        }
      } catch (e) {
        console.error('ERR ADDING ITEM', e)
      }
    }

    function itemAdded(item) {
      if (!item) return;

      const event = new Event('minicart:product-added');

      document.dispatchEvent(event);
    }
  });

  $(document).on('change', `${namespace}.minicart__featured-form [data-variant-selector]`, e => {

    const $form = $(e.target).parents(namespace).first();
    const $frequencySelect = $form.find('select[name="frequency"]');
    if (!$frequencySelect) { return }
    $frequencySelect[0].disabled = false;

    if (theme.disableRechargeVariants.indexOf(e.target.value.toString()) > -1) {
      $frequencySelect.val('one-time').trigger('change');
      $frequencySelect[0].disabled = true;

    }
  });

  $(document).on('click', '[data-qty-button]', e => {
    const button = ('qtyButton' in e.target.dataset) ? e.target : e.target.parentElement

    const n = parseInt(button.dataset.qtyButton);

    const qtyInput = $(button).siblings('.input');
    const oldValue = +qtyInput.val();

    const newValue = oldValue + n <= 0 ? 0 : (oldValue + n >= 100 ? 99 : oldValue + n)

    let status = qtyInput.attr('disabled');

    if (status != 'disabled') {
      qtyInput.val(newValue || oldValue).trigger('change');
    }
  })
});

function checkProductPreorder(additionalSelector = '') {
  if (!('preorderProducts' in window)) return

  const namespace = '.js-recharge-product-form';

  const forms = document.querySelectorAll(additionalSelector + namespace)

  for (const form of forms) {
    const handle = form.dataset.productHandle;

    if (handle in preorderProducts) {
      const $addToCart = $(form).find('[data-add-to-cart]');

      $addToCart.addClass('button--preorder');
      $addToCart.find('[data-add-to-cart-text]').replaceWith(`<span data-preorder-text>${preorderProducts[handle].buttonText}</span>`)

      const preorderInfoLabel = form.querySelector('.js-preorder-info');

      if (preorderInfoLabel) {
        if (preorderProducts[handle].infoLabel) {
          preorderInfoLabel.innerHTML = preorderProducts[handle].infoLabel;
          preorderInfoLabel.classList.remove('visually-hidden');
        } else {
          preorderInfoLabel.remove();
        }
      } else {
        $addToCart.append(`<span data-preorder-info>${preorderProducts[handle].buttonLabel}</span>`)
      }

      // if (!form.classList.contains('fixed-cart-form') && !$addToCart.find('[data-preorder-info]').length) {
      //     $addToCart.append(`<span data-preorder-info>${preorderProducts[handle].buttonLabel}</span>`)
      // } else if (form.classList.contains('fixed-cart-form')) {
      //     const label = form.querySelector('.fixed-cart-form__action .fixed-cart-form__label')
      //     label.innerHTML = 'Pre-order ' + preorderProducts[handle].buttonLabel
      //     label.classList.remove('fixed-cart-form__label--hidden')

      //     const actionCol = form.querySelector('.fixed-cart-form__action')

      //     if (actionCol) {
      //         actionCol.classList.remove('placeholder-hidden')
      //     }

      //     // const buttonText = form.querySelector('.fixed-cart-form__action [data-preorder-text]')

      //     // buttonText.innerHTML = buttonText.innerHTML + ' now';
      // }
    }
  }

}
accountDetails();


function accountDetails() {
  let accountPage = $('.js-account-page');
  let rechargePage = $('#recharge-novum');

  if (!accountPage.length && !rechargePage.length) {
    return;
  }

  // Code for Country/province select logic
  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify && false) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });


  this.accountTabLinks = $('.js-account-tab-link');
  this.accountTabsContent = $('.js-account-tab');

  this.$addAddressPopup = $('#adress-add-modal');
  this.addAddressButton = $('.js-show-address-popup');
  this.closeNewAddressButton = $('.js-close-new-address-popup');

  this.editAddressButton = $('.js-address-edit');
  this.closeEditAddressButton = $('.js-close-edit-address-popup');

  this.addListenerForNavigation = function () {
    $(document).on('click', '.js-account-navigation-toggler', e => {
      $('.js-account-navigation').toggleClass('account-navigation--opened')
    })
  };

  this.toggleTab = function () {
    this.accountTabLinks.click((e) => {
      e.preventDefault();

      $('.js-account-navigation').removeClass('account-navigation--opened');

      let currentElement = $(e.currentTarget);

      this.accountTabLinks.removeClass('active');
      this.accountTabLinks.toArray().filter(x => x.getAttribute('href') == currentElement.attr('href')).forEach(x => x.classList.add('active'));

      $('.js-account-navigation-toggler span').html(currentElement.html());

      this.accountTabsContent.hide();
      $(currentElement.attr('href')).show();


      const newLocation = location.hash ? location.href.replace(location.hash, currentElement.attr('href')) : location.href + currentElement.attr('href');

      history.replaceState(null, null, newLocation)
    });

    this.toggleActiveTab();
    window.addEventListener('hashchange', this.toggleActiveTab.bind(this))
  };

  this.toggleActiveTab = function () {
    if (location.hash) {
      const activeTab = this.accountTabLinks.toArray().find(x => '#' + x.href.split('#').pop() == location.hash);
      if (activeTab) $(activeTab).click();
    }
  };

  this.showNewAddressPopup = function () {
    $(document).on('click', '.js-show-address-popup', e => {
      // this.addAddressButton.click((e) => {
      e.preventDefault(e);
      this.$addAddressPopup.addClass('popup--opened');
      this.$addAddressPopup.find('.overlay').addClass('overlay--shown')
      if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
        $('body').css({
          position: 'fixed',
          overflow: 'hidden'
        })
      } else {
        bodyScrollLock.disableBodyScroll(this.$addAddressPopup[0]);
      }
    });
  };

  this.closeNewAddressPopup = function () {
    $(document).on('click', '.js-close-new-address-popup', e => {
      // this.closeNewAddressButton.click((e) => {
      e.preventDefault(e);
      this.$addAddressPopup.removeClass('popup--opened');
      this.$addAddressPopup.find('.overlay').removeClass('overlay--shown')
      if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
        $('body').css({
          position: 'relative',
          overflow: 'initial'
        })
      } else {
        bodyScrollLock.enableBodyScroll(this.$addAddressPopup[0]);
      }
    });
  };

  this.showEditAddressPopup = function () {
    console.log(true)

    $(document).on('click', '.js-address-edit', e => {

      console.log(true)
      e.preventDefault(e);
      let addressId = $((e).currentTarget).attr('data-form-id');
      let $editAddressPopup = $('#adress-edit-modal_' + addressId);

      if (!$editAddressPopup.length) return

      $editAddressPopup.addClass('popup--opened');
      $editAddressPopup.find('.overlay').addClass('overlay--shown')
      if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
        $('body').css({
          position: 'fixed',
          overflow: 'hidden'
        })
      } else {
        bodyScrollLock.disableBodyScroll($editAddressPopup[0]);
      }
    });
  };

  this.closeEditAddressPopup = function () {
    $(document).on('click', '.js-close-edit-address-popup', e => {
      e.preventDefault(e);
      let $editAddressPopup = $((e).currentTarget).parents('.popup');

      if (!$editAddressPopup.length) return

      $editAddressPopup.removeClass('popup--opened');
      $editAddressPopup.find('.overlay').removeClass('overlay--shown')

      if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
        $('body').css({
          position: 'relative',
          overflow: 'initial'
        })
      } else {
        bodyScrollLock.enableBodyScroll($editAddressPopup[0]);
      }
    });
  };

  /*let postLink1 = function(t, e) {
      e = e || {};
      var n = e.method || "post"
          , i = e.parameters || {}
          , o = document.createElement("form");
      o.setAttribute("method", n),
          o.setAttribute("action", t);
      for (var r in i) {
          var l = document.createElement("input");
          l.setAttribute("type", "hidden"),
              l.setAttribute("name", r),
              l.setAttribute("value", i[r]),
              o.appendChild(l)
      }
      document.body.appendChild(o),
          o.submit(),
          document.body.removeChild(o)
  };*/

  let postLink = function (url, settings) {
    settings = settings || {};
    let method = settings.method || "post";
    let parameters = settings.parameters;
    let data = {};

    for (let param in parameters) {
      data[param] = parameters[param];
    }

    $.ajax({
      method: method,
      url: url,
      data: data,
      headers: { "cache-control": "no-cache" },
      success: function () {
        location.reload(true);
      }
    })
  };

  this.deleteAddress = function () {
    $('.js-address-delete').on('click', function () {
      let $el = $(this);
      let formId = $el.data('form-id');
      let confirmMessage = $el.data('confirm-message');
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });

        // added reload page, because on Iphone X the page does't reload automatically;
        // setTimeout(function() {
        //     console.log('restart page 500');
        //     location.reload();
        // }, 500);
      }
    });
  };

  this.addListenerForNavigation();

  this.toggleTab();

  this.showNewAddressPopup();
  this.closeNewAddressPopup();

  this.showEditAddressPopup();
  this.closeEditAddressPopup();

  this.deleteAddress();
}


$(document).ready(function () {

  toggleIngredientsPopup();

  function toggleIngredientsPopup() {

    let ingredientsLinks = $('.js-ingredient-link');

    if (ingredientsLinks.length < 1) {
      return false;
    }

    let ingredientPopup = $('.popup-ingredient');

    ingredientsLinks.click(function (e) {
      e.preventDefault();

      if (window.innerWidth > 991) {
        return;
      }

      let ingredientContent = ($(this).parent().find('.js-ingredient-popup'))[0].outerHTML;

   //    $('body').append('<div class="popup popup-ingredient popup--opened popup-fadein1"><div class="overlay overlay--shown"></div><div class="popup__container"><button class="popup__close-wrapper js-ingredient-popup-close"><div class="popup__close"></div></button> ' + ingredientContent + '</div></div>');

      ingredientPopup.find('.popup__container').html(ingredientContent);

      ingredientPopup.addClass('popup--opened');
      ingredientPopup.find('.overlay').addClass('overlay--shown');

      bodyScrollLock.disableBodyScroll(ingredientPopup.find('.ingredient-popup')[0]);
    });

    $('.js-ingredient-popup-close').on('click touchstart', e => {
      closePopup();

      e.stopImmediatePropagation();
      e.preventDefault();
      e.stopPropagation();

      return false;
    });

    $('body').on('click touchstart', function (event) {
      if ($(event.target).parents('.js-ingredient-popup-close').length || event.target.classList.contains('js-ingredient-popup-close')) {
        closePopup();
        return false;
      }
      if ($(event.target).parents('.js-ingredient-link').length || event.target.classList.contains('js-ingredient-link')) {
        return true;
      }
      if (!$(event.target).parents('.ingredient-popup').length && !event.target.classList.contains('ingredient-popup')) {
        closePopup();
      }
    });

    function closePopup() {
      ingredientPopup.removeClass('popup--opened');
      ingredientPopup.find('.overlay').removeClass('overlay--shown');

      bodyScrollLock.clearAllBodyScrollLocks();
    }

  }
});  



$(document).ready(function () {

  window.orderPopup = new Vue({
    el: '#single-order-popup',
    data() {
      return {
        isActive: false,
        order: null
      }
    },
    methods: {
      toggleWithData(order) {
        this.order = order

        if (this.order) {
          this.isActive = true
        }
      }
    },
    watch: {
      isActive(v) {
        if (v) {
          bodyScrollLock.disableBodyScroll(this.$el)
        } else {
          bodyScrollLock.enableBodyScroll(this.$el)
        }
      }
    },
    filters: {
      money(v) {
        return slate.Currency.formatMoney(v);
      }
    }
  })

  $(document).on('click', '.js-toggle-order-popup', e => {
    e.preventDefault();
    const orderData = parseOrderData(orders.get(e.target.getAttribute('data-order-name')));
    if (window.orderPopup) {
      window.orderPopup.toggleWithData(orderData)
    }
  })

});

function parseOrderData(order) {

  for (let line_item of order.line_items) {
    if (line_item.fulfillment) {
      line_item.fulfillment.created_at = new Date(line_item.fulfillment.created_at).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    }
  }

  return order
}
; (function () {

  const $window = $(window)

  let lastPosition = $window.scrollTop();
  const $header = $('#header-main');
  const $body = $('body');

  const topOffsetPosition = 50

  $window.on('scroll touchmove', e => {
    // if (window.innerWidth < 1200) return true;

    if (document.body.classList.contains('minicart-opened')) return true

    const currentPosition = $window.scrollTop();

    // if ($body.height() - window.innerHeight < 150) {
    //     return true;
    // }

    // if ($body.height() - currentPosition - window.innerHeight < 50) {
    //     if (!$header.hasClass('header--hidden')) {
    //         $header.addClass('header--hidden');
    //         $body.addClass('no-header')
    //     }
    //     return true
    // }

    if (currentPosition < topOffsetPosition) {
      $header.removeClass('header--hidden');
      $body.removeClass('no-header')
      return true;
    }

    if (currentPosition < lastPosition) {
      $header.removeClass('header--hidden');
      $body.removeClass('no-header')
    } else if (currentPosition > lastPosition) {
      $header.addClass('header--hidden');
      $body.addClass('no-header')
    }

    lastPosition = currentPosition;
  })

}());
$(document).ready(function () {
  initWaitlistPopup('waitlist-popup')

  function initWaitlistPopup(identifier) {
    const waitlistPopupEl = document.querySelector(`#${identifier}`)

    if (!waitlistPopupEl) return

    const klaviyoSubscribeURL = "https://a.klaviyo.com/ajax/subscriptions/subscribe"

    window.waitlistPopup = new Vue({
      el: waitlistPopupEl,
      data: function () {
        return {
          email: __st.cid && customerEmail ? customerEmail : '',
          isActive: false,
          isSubmitted: false,
          isLoading: true,
          hasEmailErrors: false
        }
      },
      methods: {
        togglePopup() {
          this.isActive = !this.isActive
        },
        subscribe() {
          if (!this.email || !validateEmail(this.email)) {
            this.hasEmailErrors = true
            return
          }

          this.hasEmailErrors = false

          const data = {
            g: this.$el.dataset.klaviyoListId,
            '$fields': '$source,$email,$consent_method,$consent_form_id,$consent_form_version',
            '$list_fields': '',
            '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
            '$source': 'Form for popup',
            '$email': this.email,
            '$consent_method': 'Klaviyo Form',
            '$consent_form_id': this.$el.dataset.klaviyoFormId,
            '$consent_form_version': 121296
          }

          fetch(klaviyoSubscribeURL, {
            "method": "POST",
            "mode": "cors",
            "credentials": "omit",
            "headers": {
              "access-control-allow-headers": "*",
              "content-type": "application/x-www-form-urlencoded; charset=utf-8"
            },
            "referrer": location.href,
            "referrerPolicy": "no-referrer-when-downgrade",
            "body": Object.keys(data).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`).join('&')
          })
            .then(res => res.json())
            .then(data => {
              if (data.success) {
                this.isSubmitted = true
              }
            })
        }
      },
      watch: {
        isActive(v) {
          if (v) {
            bodyScrollLock.disableBodyScroll(this.$el)
          } else {
            setTimeout(() => this.isSubmitted = false, 400)
            bodyScrollLock.enableBodyScroll(this.$el)
          }
        }
      }
    })

    $(document).on('click', `.js-toggle-${identifier}`, () => {
      if (window.waitlistPopup) {
        window.waitlistPopup.togglePopup()
      }
    })
  }

  function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
});
; (function () {

  const klaviyoSubscribeURL = "https://a.klaviyo.com/ajax/subscriptions/subscribe"

  $(document).on('click', '[data-klaviyo-subscribe]', sendRequest)

  window.successPopup = new Vue({
    el: '#subscribe-confirmation-popup',
    data() {
      return {
        isActive: false
      }
    },
    methods: {
      togglePopup() {
        this.isActive = !this.isActive
      },
    },
    watch: {
      isActive(v) {
        if (v) {
          bodyScrollLock.disableBodyScroll(this.$el)
        } else {
          bodyScrollLock.enableBodyScroll(this.$el)
        }
      }
    }
  })

  function sendRequest(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!('klaviyoSubscribe' in e.target.dataset)) return false

    const emailInput = e.target.parentElement.querySelector('input[type="email"]')

    if (!emailInput) return false

    const email = emailInput.value

    if (!email || !validateEmail(email)) {
      emailInput.classList.add('input--error')
      return false
    }

    let data = {
      g: e.target.dataset.klaviyoSubscribe,
      '$fields': '$source,$email,$consent_method,$consent_form_id,$consent_form_version,VidaStories',
      '$list_fields': '',
      '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
      '$source': 'Newsletter',
      '$email': email,
      '$consent_method': 'Klaviyo Form',
      '$consent_form_id': e.target.dataset.klaviyoFormId,
      '$consent_form_version': 61852
    }

    if (e.target.parentElement.querySelector('input[name="tag"]')) {
      data['$source'] = 'VidaStories';
      data['VidaStories'] = 'true';
    }

    fetch(klaviyoSubscribeURL, {
      "method": "POST",
      "mode": "cors",
      "credentials": "omit",
      "headers": {
        "access-control-allow-headers": "*",
        "content-type": "application/x-www-form-urlencoded; charset=utf-8"
      },
      "referrer": location.href,
      "referrerPolicy": "no-referrer-when-downgrade",
      "body": Object.keys(data).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`).join('&')
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          window.successPopup.togglePopup()
        }
      })
  }

  function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  $(document).on('input', '.input--error', e => {
    e.target.classList.remove('input--error')
  })

}());


$(document).ready(function () {

  initFeaturesToggler();

  function initFeaturesToggler() {
    let toggleButtons = $('.js-feature-text-toggler');

    toggleButtons.click(function () {
      let featureItem = $(this).parents('.js-feature-item');
      let hiddenContent = featureItem.find('.js-feature-hidden-content');

      $(this).toggleClass('home-features__toggle-button--expanded');
      hiddenContent.stop().slideToggle();
    });
  }

  $('.input-radio').on('click', function () {
    const selected_variant = $(this).find('input').val();
    $('.add_sample').hide();
    $('.sample[data-variant-id="' + selected_variant + '"]').fadeIn();
  });

  $('.mobile-inline-form__item[data-variant-selector]').on('change', function () {
    const selected_variant = $(this).find('option:selected').val();

    $('.add_sample').hide();
    $('.sample[data-variant-id="' + selected_variant + '"]').fadeIn();
  });

  $('.select--frequency, [name="frequency"]').on('change', function () {
    const value = $(this).find('option:selected').val();
    let $quadpay = $("quadpay-widget-v3");
    // const $addToCartText = $('[data-add-to-cart-text]');
    // const $subscriptionBtn = $('button[data-open-add-to-existing]');
    let $samples = $('.add_sample');
    let current_variant;

    if (window.matchMedia('(max-width: 991px)').matches) {
      current_variant = $('.mobile-inline-form__item[data-variant-selector] option:checked').val();
    } else {
      current_variant = $('[name="variant"]:checked').val();
    }

    if (value !== 'one-time') {
      $samples.hide();
      $quadpay.hide();
      $('.sample_subscription[data-variant-id="' + current_variant + '"]').fadeIn();
      //$subscriptionBtn.fadeIn();
      //if ($addToCartText.html() !== 'new subscription')
      //    $addToCartText.html('new subscription');

    } else {
      // $subscriptionBtn.hide();
      $samples.hide();
      $quadpay.show();
      $('.sample[data-variant-id="' + current_variant + '"]').fadeIn();
      // if ($addToCartText.html() === 'new subscription')
      //     $addToCartText.html('add to cart');
    }
  });

  if (window.location.search.indexOf('add-products') !== -1) {
    setTimeout(function () {
      var history = window.location.search.replace('add-products', '');
      if (history.length == 1) {
        history = '';
      }
      window.history.pushState({}, document.title, "/" + history);
      $('.minicart__wrapper [data-add-to-cart]').click();
    }, 1000);

  }

  if ($('.Announcement__Slider').length) {
    document.documentElement.style.setProperty('--product-nav-position', ($('.Announcement').height() + $('#header-main').height()) + "px");

    if ($('body').hasClass('template-product')) {
      document.documentElement.style.setProperty('--body-padding', ($('.Announcement').height() + $('#header-main').height() + $('#product-navigation').height()) + "px");
    } else {
      document.documentElement.style.setProperty('--body-padding', ($('.Announcement').height() + $('#header-main').height()) + "px");
    }

    $('body').addClass('hasAnnouncement');

    $('.Announcement__Slider:not(.slick-initialized)').slick({
      dots: false,
      infinite: true,
      arrows: false,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 4000
    })
  }

  if (!sessionStorage.getItem('changeLocation')) {
    $.getJSON('https://ipapi.co/json/', function (data) {
      if (data.country === "FR") {
        $('.CountryPopup').fadeIn();
      }
    });
  }

  if ($('[data-show-for-countries]').length) {
    $.getJSON('https://ipapi.co/json/', function (data) {
      $.each($('[data-show-for-countries]').attr('data-show-for-countries').split(', '), function (i, item) {
        if (data.country === item) {
          $('[data-show-for-countries]').fadeIn();
        }
      })
    });
  }



  $('.CountryPopup__Close').on('click', function (e) {
    e.preventDefault();
    $('.CountryPopup').fadeOut();
    sessionStorage.setItem('changeLocation', 'false')
  });

  if ($('.slick-hero-slider').length) {
    var sliderData = {
      adaptiveHeight: true
    }
    if ($('.slick-hero-slider').attr('data-autoplay') == 'true') {
      sliderData.autoplay = true;
      sliderData.autoplaySpeed = $('.slick-hero-slider').attr('data-autoplay').length ? (parseInt($('.slick-hero-slider').attr('data-autoplay-speed')) * 1000) : 3000;
    }
    $('.slick-hero-slider').slick(sliderData);
  }

  function landingProductSlider(slider, dots, arrows) {
    slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      fade: true,
      dots: dots,
      infinite: true,
      arrows: arrows,
      nextArrow: '<button type="button" role="button" aria-label="Next" class="slick-arrow slick-next"></button>',
      prevArrow: '<button type="button" role="button" aria-label="Previous" class="slick-arrow slick-prev"></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }

  function landingResultSlider(slider) {
    if (window.innerWidth < 992 && !slider.hasClass('slick-initialized')) {
      slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        fade: true,
        dots: true,
        infinite: true,
        arrows: false
      });
    } else if (window.innerWidth > 991 && slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
  }

  if ($('.landing-product-slider').length) {
    $('.landing-product-slider').each(function () {
      var sectionId = $(this).parent().attr('id'),
        $slider = $('.landing-product-slider-' + sectionId),
        dots = $slider.data('dots'),
        arrows = $slider.data('arrows');
      landingProductSlider($slider, dots, arrows)

      $('label').on('click', function () {
        let $thisInput = $('#' + $(this).attr('for'));

        console.log($thisInput.val())
        var slideIndex = $(`[data-var-img='${$thisInput.val()}']`).attr('data-slick-index')


        if ($(`[data-var-img='${$thisInput.val()}']`).length) {
          $slider.slick('slickGoTo', slideIndex);
        }
      })
    })
  }

  if ($('.landing-product-content-result').length) {
    $('.landing-product-content-result-wrapper').each(function () {
      var sectionId = $(this).parent().attr('id'),
        $slider = $('.landing-product-content-result-wrapper-' + sectionId);
      landingResultSlider($slider)
      $(window).on('resize', function () {
        landingResultSlider($slider)
      });
    })
  }

  if (location.href.includes('/pages/subscription-program') && location.hash.includes('faq')) {
    $('body, html').animate({
      scrollTop: $("#faq").offset().top - 120
    }, 700);
  }

  $(document).on('remove-hero-banner-slides', function () {
    console.log($('.hero-banner').slick('slickRemove', 1))
    $('.hero-banner').slick('slickRemove', 1);
    $('.hero-banner').slick('slickRemove', 2);
  })

  $('.video-popup').on('click', function (e) {
    e.preventDefault();
    const $videoPopup = $('.VideoPopup')
    const $iframe = $videoPopup.find('iframe')

    if ($iframe.attr('data-src').length) {
      $iframe.attr('src', $iframe.attr('data-src'))
    }

    $('body').css('overflow', 'hidden')
    $videoPopup.fadeIn()

    bodyScrollLock.disableBodyScroll($('.VideoPopup')[0]);
  })

  $('.js-close-video-popup').on('click', function (e) {
    e.preventDefault();
    const $videoPopup = $('.VideoPopup')
    $('body').css('overflow', 'visible')

    $videoPopup.fadeOut();
    $videoPopup.find('iframe').attr('src', '')
    bodyScrollLock.clearAllBodyScrollLocks();
  })

  if (theme.enable_promo_gwp && theme.promo_gwp_param && location.search.indexOf('promo=' + theme.promo_gwp_param) !== -1) {
    localStorage.setItem('promo_gwp', theme.promo_gwp_param);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var endlessScroll = new Ajaxinate();
});
 